<template>
    <div class="tile">
        <div class="tile-title">
            <h2>Additional criteria</h2>
        </div>
        <div class="tile-content">
            <condition-summary :criteria="gateway.additionalCriteria" :field-provider="fieldProvider"/>
        </div>
    </div>
</template>

<script>
    import detailsMixins from './details-mixins';
    import ConditionSummary from '@/modules/rules-engine/components/condition-summary/condition-summary';
    import FieldProvider from '@/modules/rules-engine/components/condition-builder/field-provider';
    import getFieldsFromPathways from '@/modules/rules-engine/components/condition-builder/get-fields-from-pathways';
    import resolveFilterType from '@/components/query/helpers/resolve-filter-type';
    import additionalCriteriaEvent from '@/modules/gateway-accounts/components/details/additional-criteria-event';

    export default {
        name: 'gateway-additional-criteria',
        mixins: [detailsMixins],
        components: {
            ConditionSummary,
        },
        computed: {
            fieldProvider() {
                return new FieldProvider({
                    pathwayResolver: getFieldsFromPathways,
                    typeResolver: resolveFilterType,
                    pathways: additionalCriteriaEvent.pathways,
                    customFieldsStore: this.$store.getters['rulesEngine/customFields'],
                });
            },
        },
    };
</script>
